module.exports = __webpack_public_path__ + "static/assets/GlacialIndifference-Bold.cac876df.woff2";